import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/stateDetail',
    name: 'stateDetail',
    component: () => import('../views/stateDetail.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about.vue')
  },
  {
    path: '/connection',
    name: 'connection',
    component: () => import('../views/connection.vue')
  },
  {
    path: '/txt',
    name: 'txt',
    component: () => import('../views/Txt.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/product.vue')
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: () => import('../views/xpdf.vue')
  },
  {
    path: '/system',
    name: 'system',
    component: () => import('../views/system.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
